import { render, staticRenderFns } from "./WIN_two_column_fullbleed.vue?vue&type=template&id=79dafdb2&"
import script from "./WIN_two_column_fullbleed.vue?vue&type=script&lang=js&"
export * from "./WIN_two_column_fullbleed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports